import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import qs from 'query-string';

import ResetPasswordForm from '../../forms/PasswordReset';
import PageMeta from '../../modules/PageMeta';
import PageSection from '../../modules/PageSection';
import SidebarColumn from '../../modules/SidebarColumn';
import ContentColumn from '../../modules/ContentColumn';
import PageSidebar from '../../modules/PageSidebar';
import AlertBox from '../../modules/AlertBox';
import Page from '../../pages/Page';
import ReferrerLink from '../../modules/ServiceReferrerLink';

import * as resetActions from '../../../actions/password_reset';
import * as serviceActions from "../../../actions/services";
import AlertMessage from "../../modules/AlertMessage/index";
import {TNA_IDS} from "../../../constants/services";

class PasswordReset extends React.Component {

    constructor() {
        super();

        this._submit = this._submit.bind(this);
    }

    componentDidMount() {
        const serviceId = qs.parse(this.props.location.search).service;

        this.props.refreshServiceReferrer(serviceId);
    }

    _getSearchParams() {
        return qs.parse(this.props.location.search);
    }

    _submit(values) {

        const code = this._getSearchParams().code;

        return this.props.resetPassword({ ...values, code })
            .then(() => {

                const { serviceReferrer } = this.props;

                if (serviceReferrer) {
                    this.props.history.push(`/login?password_reset=true&service=${serviceReferrer.id}`);
                } else {
                    this.props.history.push(`/login?password_reset=true`);
                }
            });
    }

    render() {

        const queryParams = this._getSearchParams();

        const { serviceReferrer } = this.props;

        return (
            <Page>
                <PageMeta title="Password Reset" />

                <SidebarColumn>
                    <PageSidebar />
                </SidebarColumn>

                <ContentColumn>

                    {!!queryParams.service && serviceReferrer && TNA_IDS.includes(parseInt(queryParams.service)) &&
                        <AlertMessage>
                            <AlertBox theme="warning">
                                Members of the public should return to The Noise App mobile app after resetting their password. If
                                you have any issues logging in via the mobile app, please <Link to="/support">contact support</Link>
                            </AlertBox>
                        </AlertMessage>
                    }

                    {!!queryParams.service && serviceReferrer &&
                        <PageSection>
                            <ReferrerLink service={serviceReferrer}/>
                        </PageSection>
                    }

                    <PageSection>

                        <AlertMessage>
                            {(queryParams.invalid_code === 'true' || queryParams.confirmed === 'true') && (
                                <AlertBox
                                    theme={queryParams.confirmed === 'true' ? 'success' : 'danger'}
                                >
                                    {queryParams.confirmed === 'true' ? 'Your account has been confirmed successfully, please choose a password for your account.'
                                        : <p>The reset link you used is no longer valid. Try finding a more recent password reset email from us or send it again using the <Link to="/forgotten-password">forgotten password</Link> page.</p>}
                                </AlertBox>
                            )}
                        </AlertMessage>

                        {!queryParams.invalid_code &&

                            <ResetPasswordForm onSubmit={this._submit} />
                        }

                    </PageSection>

                </ContentColumn>
            </Page>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        serviceReferrer: state.services.serviceReferrer
    }
};

const mapDispatchToProps = dispatch => {
    return {
        refreshServiceReferrer(serviceId) {
            dispatch(serviceActions.refreshServiceReferrer(serviceId));
        },
        resetPassword(params) {
            return dispatch(resetActions.resetPassword(params));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PasswordReset);
